import React, { Component } from 'react';
import { Row, Col } from 'reactstrap';
import { withLocale } from '@dietlabs/components';
import Markdown from 'markdown-to-jsx';
import PropTypes from 'prop-types';

class FavMealDish extends Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        recipe: PropTypes.string.isRequired,
        t: PropTypes.func.isRequired,
        children: PropTypes.func.isRequired,
    };

    render() {
        const replaceSpanToOl = ({ children }) => (
            <ol>
                <li>{children.slice(3)}</li>
            </ol>
        );

        return (
            <div className="dish">
                <h2 className="dishName">{this.props.name}</h2>
                <Row>
                    <Col md="5">{this.props.children()}</Col>

                    {this.props.recipe !== '' ? (
                        <Col md={{ size: 6, offset: 1 }}>
                            <div className="recipe">
                                <h4>{this.props.t('meal/how-to-prepare')}:</h4>
                                {this.props.recipe && (
                                    <Markdown
                                        start="1"
                                        options={{
                                            overrides: {
                                                span: {
                                                    component: replaceSpanToOl,
                                                },
                                            },
                                        }}
                                    >
                                        {this.props.recipe}
                                    </Markdown>
                                )}
                            </div>
                        </Col>
                    ) : (
                        ''
                    )}
                </Row>
            </div>
        );
    }
}

export default withLocale(FavMealDish);
